import React, { useState, useEffect } from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "../EmployeeSection/Employeewithdrawlist.css";
import Base from "../admin_components/Admin_Base";
import { Breadcrumbs } from "@mui/material";
import Link from "@mui/material/Link";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { ADMIN_API_BASE_URL } from "../Auth/Api";
import authAxios from "../Auth/useAxios";
import { ClipLoader } from "react-spinners";

const EmployeeWalletWithdrawList = () => {
  const [withdrawalist, setWithDrawaList] = useState([]);
  const [filterStatus, setFilterStatus] = useState("all");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    fetchIncentiveWithdrawList();
  }, []);

  const fetchIncentiveWithdrawList = async () => {
    try {
      const response = await authAxios.get(
        `${ADMIN_API_BASE_URL}/main/admin/incentive-withdraw-requests/all`
      );

      setWithDrawaList(response.data);
      console.log(response.data, "treeee");
    } catch (error) {
      console.error("❌ Error fetching all employees:", error);
    } finally {
      setLoading(false);
    }
  };


  // Filter
  const filteredRequests = withdrawalist.filter((request) => {
    if (filterStatus === "all") return true; // Show all requests
    return request.status.toLowerCase() === filterStatus.toLowerCase();
  });

  // Pagination Logic
  const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedRequests = filteredRequests.slice(startIndex, endIndex);

  const convertToCSV = (data) => {
    const headers = [
      "S.No",
      "Employee Name",
      "Employee ID",
      "Withdraw Amount",
      "Status",
    ];
    const rows = data.map((request) => [
      request.sno,
      request.employeeName,
      request.employeeId,
      request.withdrawAmount,
      request.status,
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.join(",")),
    ].join("\n");

    return csvContent;
  };

  const handleDownload = () => {
    const csvData = convertToCSV(filteredRequests);
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "employee_withdrawals.csv";
    link.click();
    URL.revokeObjectURL(url);
  };

  return (
    <Base>
      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "300px" }}>
          <ClipLoader color="darkslategrey" size={50} />
        </div>
      ) : error ? (
        <div>{error}</div>
      ) : (
        <>
          <div className="pt-3 mt-5 addarea_labels pr-3">
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              <Link
                underline="hover"
                key="1"
                color="inherit"
                href="/admin/dashboard"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Dashboard
              </Link>
              <Link
                underline="hover"
                key="3"
                color="inherit"
                href="/admin/admin_employee_walletwithdraw_list"
                sx={{ color: "darkslategrey", fontWeight: "bold" }}
              >
                Employee Wallet Withdraw List
              </Link>
            </Breadcrumbs>
          </div>

          <h2 className="text-center fw-bold main_heading">
            Employee Wallet Withdraw List
          </h2>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <hr style={{ width: "94%" }} />
          </div>

          <div className="employee-withdraw-container ">
            <div className="filter-container">
              <label htmlFor="status-filter">Filter by Status: </label>
              <select
                id="status-filter"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All</option>
                <option value="pending">Pending</option>
                <option value="approved">Approved</option>
                <option value="rejected">Rejected</option>
              </select>

              <button onClick={handleDownload} className="download-button-withdraw">
                Download Excel
              </button>
            </div>

            <Table className="responsive-table-withdraw customer-table">
              <Thead>
                <Tr>
                  <Th>S.No</Th>
                  <Th>Employee Name</Th>
                  <Th>Employee ID</Th>
                  <Th>Withdraw Amount</Th>
                  <Th>Status</Th>
                </Tr>
              </Thead>
              <Tbody>
                {paginatedRequests.map((request, index) => (
                  <Tr key={request.id}>
                    <Td>{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                    <Td>{request.employeeName}</Td>
                    <Td>{request.employeeId}</Td>
                    <Td>{request.withdrawAmount}</Td>
                    <Td>
                      <span
                        className={`status-badge ${request.status.toLowerCase()}`}
                      >
                        {request.status}
                      </span>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>

            <div className="pagination-controls-withdraw">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="mx-2">
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </Base>
  );
};

export default EmployeeWalletWithdrawList;
